/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react' // useEffect añadido para Google Analytics
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import { DevTool } from 'little-state-machine-devtools'
import { AuthGuard } from './components/Auth/AuthGuard'
import { AuthProvider } from './context/auth.context'
import { GeneralProvider } from './context/general.context'
import { AccountDetail } from './pages/Account/AccountDetail'
import { AccountEvents } from './pages/Account/AccountEvents'
import { AccountLayout } from './pages/Account/AccountLayout'
import { AccountPayment } from './pages/Account/AccountPayments'
import { ChangePasswordPage } from './pages/ChangePassword'
import { DashboardHomePage } from './pages/Dashboard/Home'
import { EventDiscoverPage } from './pages/Events/EventDiscover'
import { EventDetail } from './pages/Events/EventDetail'
import { VenueDetail } from './pages/Venues/VenueDetail'
import { ArtistDetail } from './pages/Artists/ArtistDetail'
import { UpdateEventPage } from './pages/Events/UpdateEvent'
import { Layout } from './pages/Layout'
import { LoginPage } from './pages/Login'
import { NotFoundPage } from './pages/NotFound'
import { NoticePrivacyPage } from './pages/NoticePrivacy'
import { RecoverPasswordPage } from './pages/RecoverPassword'
import { TermsConditionsPage } from './pages/TermsConditions'
import { initAxiosInterceptors } from './services/auth.service'
import { AccountPassword } from './pages/Account/AccountPassword'
import { EventLayout } from './pages/Events/EventLayout'
import { InformationEvent } from './pages/Events/CreateEvent/InformationEvent'
import { StateMachineProvider, createStore } from 'little-state-machine'
import { InformationOrganizer } from './pages/Events/CreateEvent/InformationOrganizer'
import { InformationTickets } from './pages/Events/CreateEvent/InformationTickets'
import { InformationSummary } from './pages/Events/CreateEvent/InformationSummary'
import { ContentLayoutPage } from './pages/Dashboard/ContentLayoutDashboard'
import { initialStates } from './hooks/useLittleMachine'
import { ButtonTest } from './pages/ButtonTest'
import { CreateUsers } from './pages/Dashboard/Users/CreateAdmin'
import { ListCategories } from './pages/Dashboard/Categories/ListCategories'
import { ListUsers } from './pages/Dashboard/Users/ListUsers'
import { EditUsers } from './pages/Dashboard/Users/EditUser'
import { EditCategory } from './pages/Dashboard/Categories/EditCategory'
import { AproveEvents } from './pages/Dashboard/Events/AproveEvents'
import { CreateCategories } from './pages/Dashboard/Categories/CreateCategory'
import { AccountPublications } from './pages/Account/AccountPublications'
import { AccountStats } from './pages/Account/AccountStats'
import { AccountStatsTotal } from './pages/Account/AccountStatsTotal'
import { ListEventsAproved } from './pages/Dashboard/Events/ListEventsAproved'
import { ListEventsDeleted } from './pages/Dashboard/Events/ListEventsDeleted'
import { ListPayments } from './pages/Dashboard/PaymentMethods/ListPayments'
import { CreatePayments } from './pages/Dashboard/PaymentMethods/CreatePayment'
import { EditPayment } from './pages/Dashboard/PaymentMethods/EditPayment'
import { RevisionPage } from './pages/Events/RevisionPage'
import { RegisteredAttendancePage } from './pages/Events/RegisteredAttendance'
import { AccountEventDetails } from './pages/Account/AccountEventDetails'
import { ExploreEvent } from './pages/Events/ExploreEvent'
import { ExploreVenue } from './pages/Venues/ExploreVenue'
import { LoggedGuard } from './components/Auth/LoggedGuard'
import { DownloadApp } from './pages/DownloadApp'
import { EventPayment } from './pages/Events/EventPayment'
import { TermsConditionsApp } from './pages/TermsConditionsApp'
import { data } from './data/index'
import { MerchandisingDetail } from './pages/Merchandising/MerchandisingDetail'
import { HelmetProvider } from 'react-helmet-async'

initAxiosInterceptors()
createStore({
  createEvent: initialStates.createEvent
})

// eslint-disable-next-line react/display-name
export default () => (
  <GeneralProvider>
    <AuthProvider>
      <StateMachineProvider>
        {/* {process.env.NODE_ENV !== 'production' && <DevTool />} */}
        <HelmetProvider>
        <App/>
        </HelmetProvider>
      </StateMachineProvider>
    </AuthProvider>
  </GeneralProvider>
)

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/'>
          {/* Public routes */}
          <Route element={<Layout type='user' />}>
            <Route index element={<EventDiscoverPage/>} />
            <Route path='app' element={<DownloadApp/>} />
            <Route path='terminos-de-uso' element={<TermsConditionsPage />} />
            <Route path='politica-de-privacidad' element={<NoticePrivacyPage />} />
            <Route path='terminos-condiciones-app' element={<TermsConditionsApp />} />
            <Route element={<AuthGuard typeUser={[data.userRoles.espectador]}/>}>
              <Route path='iniciar-sesion' element={<LoginPage />} />
            </Route >
            {/* <Route path="registrarse" element={<RegisterPage />} /> */}
            {/* <Route path="recuperar-password" element={<RecoverPasswordPage />} /> */}
            {/* <Route path="cambiar-password/:idCode" element={<ChangePasswordPage />} /> */}
            <Route path='eventos' element={<EventDiscoverPage />} />
            <Route path='eventos/explora' element={<ExploreEvent />} />
            <Route path='eventos/:idEvento' element={<EventDetail />} />
            <Route path='evento/:idEvento/tickets' element={<EventPayment />} />
            <Route path='evento/revision' element={<RevisionPage />} />
            <Route path='buttontest' element={<ButtonTest />} />
            <Route element = {<LoggedGuard typeUser={data.userRoles.organizador} />}>
            {/* En la ruta de arriba hay que qitar los typeUser */}
              <Route path='reserva/:idEvento' element={<RegisteredAttendancePage />} />
            </Route>
            {/* Venues */}
            <Route path='venues' element={<ExploreVenue />} />
            <Route path='venue/:idVenue' element={<VenueDetail />} />
            {/* Artists */ }
            <Route path = 'artista/:idArtist' element = {<ArtistDetail />} />
            {/* Merchandising */}
            <Route path = 'artista/:idArtist/merch/:idMerch' element = {<MerchandisingDetail />} />
            {/* Private routes general user */}
            <Route element={<AuthGuard typeUser={[data.userRoles.organizador, data.userRoles.espectador]} />}>
              <Route path="crear-evento" element={<EventLayout />}>
                <Route index element={<InformationOrganizer />} />
                <Route path='informacion-evento' element={<InformationEvent />} />
                <Route path='informacion-boletos' element={<InformationTickets />} />
                <Route path='resumen' element={<InformationSummary />} />
              </Route>
              <Route path="mis-eventos" element={<AccountLayout />}>
                <Route index element={<AccountDetail/>}/>
                <Route path="actualizar-evento" element={<UpdateEventPage />} />
              </Route>
              <Route path="mi-cuenta" element={<AccountLayout />}>
                <Route index element={<AccountDetail/>}/>
                {/* <Route path='cambiar-password' element={<AccountPassword/>}/> */}
                <Route path='metodos-pago' element={<AccountPayment/>}/>
                <Route path='reservaciones' element={<AccountEvents />} />
                <Route path='reservaciones/:id_evento' element={<AccountEventDetails/>}/>
                <Route path='publicaciones' element={<AccountPublications />} />
                <Route path='estadisticas/:idEvento' element={<AccountStats />} />
                <Route path='estadisticas/total/:idEventoTotal' element={<AccountStatsTotal />} />
              </Route>
            </Route>
          </Route>
          {/* Private routes admin */}
          <Route element={<Layout type='admin'/>}>
            <Route path='dashboard' element={<AuthGuard typeUser={[data.userRoles.administrador]} />}>
              <Route element={<ContentLayoutPage />}>
                <Route index element={<DashboardHomePage />} />
                <Route path='aprobar'>
                  <Route index element={<AproveEvents />} />
                  <Route path="eventos/:idEvento" element={<EventDetail />} />
                </Route>
                <Route path='eventos' element={<ListEventsAproved />} />
                <Route path="actualizar-evento" element={<UpdateEventPage />} />
                <Route path='eliminados' element={<ListEventsDeleted />} />
                <Route path='usuarios'>
                  <Route index element={<ListUsers />} />
                  <Route path="crear" element={<CreateUsers />} />
                  <Route path="editar/:id" element={<EditUsers />} />
                </Route>
                <Route path='categorias'>
                  <Route index element={<ListCategories />} />
                  <Route path="crear" element={<CreateCategories />} />
                  <Route path="editar/:id" element={<EditCategory />} />
                </Route>
                <Route path='metodos-pago'>
                  <Route index element={<ListPayments />} />
                  <Route path="crear" element={<CreatePayments />} />
                  <Route path="editar/:id" element={<EditPayment />} />
                </Route>
              </Route>
              <Route path="mi-cuenta" element={<AccountLayout />}>
                <Route index element={<AccountDetail />} />
                {/* <Route path='cambiar-password' element={<AccountPassword />} /> */}
              </Route>
            </Route>
          </Route>
          <Route path='recurso-no-encontrado' element={<NotFoundPage />} />
          <Route path='*' element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
